import { Container } from '@apps/ui';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import * as styles from './Layout.css';

export function Layout({ children }: { children: ReactNode }) {
  const year = new Date().getFullYear();
  return (
    <div className={styles.shell}>
      <header className={styles.header}>
        <Container>
          <div className={styles.headerInner}>
            <Link to="/" className={styles.brand}>
              Gajeroll
            </Link>
          </div>
        </Container>
      </header>
      <main className={styles.main}>
        <Container>{children}</Container>
      </main>
      <footer className={styles.footer}>
        <Container>
          <div className={styles.footerInner}>
            <nav aria-label="Footer" className={styles.footerNav}>
              <Link to="/privacy" className={styles.footerLink}>
                プライバシーポリシー
              </Link>
              <Link to="/legal" className={styles.footerLink}>
                特定商取引法に基づく表記
              </Link>
            </nav>
            <span className={styles.copyright}>© {year} 合同会社ガジェロール</span>
          </div>
        </Container>
      </footer>
    </div>
  );
}
